import styled from "styled-components";

export const Container = styled.div`
    background-color: #FFEDD1;
    padding: 24px;
    border-radius: 16px;
    h3{
        font-size: 32px;
        line-height: 40px;
        font-weight: 900;
        color: #000000;
    }
    p{
        font-size: 18px;
        line-height: 24px;
        color: #000000;
        margin-top: 16px;
    }
`;